import React from 'react';
import { definePaymentStatusClassNameMobile } from '../../../../utils/adminOrderService';

/**
 * Мобільний бейдж статусу оплати та випадаюче меню зміни статусу.
 * Одна розмітка для списку замовлень і сторінки замовлення — ідентичний DOM і класи.
 */
const AdminOrderPaymentStatusDropdownMobile = ({
  order,
  paymentStatusesEnum,
  onPickPaymentStatus,
}) => (
  <div className='dropdown mt-1'>
    <div
      className={definePaymentStatusClassNameMobile(order.paymentStatus)}
      data-toggle='dropdown'
      aria-expanded='false'
    >
      {order.paymentStatus.adminValue}
    </div>
    <div className='dropdown-menu dropdown-menu-right payment-statuses'>
      {paymentStatusesEnum
        .filter((paymentStatus) => paymentStatus.adminValue !== order.paymentStatus.adminValue)
        .map((paymentStatus, index) => (
          <a
            key={index}
            className='dropdown-item'
            onClick={() => onPickPaymentStatus(paymentStatus)}
          >
            {paymentStatus.adminValue}
          </a>
        ))}
    </div>
  </div>
);

export default AdminOrderPaymentStatusDropdownMobile;
